import styled from 'styled-components';

export const Container = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
